module.exports = __webpack_public_path__ + "img/gateway_w.1faefa3d.svg";